import {Box} from "@mui/system";

export default function StepIndicator({current = 0, total = 2}) {
    return(
        <Box sx={styles.container}>
            {`Step ${current} of ${total}`}
        </Box>
    )
}

const styles = {
    container: {
        color: '#302E2A',
        fontFamily: 'AzeretMonoRegular'
    }
}